import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  config: {},
  loading: true,
};

const configSlice = createSlice({
  name: "configSlice",
  initialState,
  reducers: {
    saveConfig: (state, action) => {
      state.config = action.payload.data;
      state.loading = false;
    },
    removeConfig: (state, action) => {
      state.config = null;
      state.loading = true;
    },
  },
});

export const { saveConfig, removeConfig } = configSlice.actions;
export default configSlice.reducer;
